import { render, staticRenderFns } from "./AlbumItem.vue?vue&type=template&id=2a204b23&scoped=true&"
import script from "./AlbumItem.vue?vue&type=script&lang=js&"
export * from "./AlbumItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a204b23",
  null
  
)

export default component.exports